import API from '../../../api';
import FormStep from '../../Form/FormStep';

export default {
	mixins: [FormStep],
	methods: {
		save() {
            // Pretty rancid map from object to id because I needed to return objects in the form for primary category select
            if(this.formData.sectors && this.formData.sectors.length > 0){
                this.formData.sectors = this.formData.sectors.map((sec) => {
                    if(typeof sec === 'object'){
                        return sec.id;
                    }

                    return sec;
                });
            }

			if(this.id) {
				return API.updateMADD(this.id, this.currentStep, this.formData);
			} else {
				return API.createMADD(this.formData).then(response => {
					this.$store.commit('form/setId', response.id);
				});
			}
		},
        sendToPreview() {
            let url = window.location.href;
            const eventCategory = url.includes("create") ? "create" : "update";
            if(window.gtag) {
                console.log("Submitting MADD submit event with category: ", eventCategory)

                window.gtag("event", "form_submission", {
                    "event_category": eventCategory,
                    "event_label": "madd"
                });
            }
			this.submit().then(ev => {
                console.log("Submitting");
				this.$router.push({ name: 'madd-preview', params: { madd_id: this.id } });
			})
		}
	},
}
